<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Prerequisite Impact"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('prerequisite_impact')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Prerequisite Impact
      Tool. The Prerequisite Impact Tool lets you view the impact of
      prerequisites on a target course.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Prerequisite Impact
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Prerequisite Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Prerequisite Filter Guide"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Prerequisite Impact Tool At First Glance ---------->

        <h3 class="h3-second-header">
          Prerequisite Impact Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 20.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPagePrereqImpactFig20']"
            alt=""
          />
          <p class="picture-caption">
            Figure 20: Prerequisite Impact Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Prerequisite Impact Form Guide ---------->
        <h3 class="h3-second-header">Prerequisite Impact Form Submission</h3>

        <ol class="ordered-list">
          <li>Enter a Course Number (Example: MAC2311)</li>
          <li>
            * Lastly, click on the ‘Submit’ button to generate results
            Prerequisite Impact.
          </li>
        </ol>
      </div>

      <div class="left-align-div">
        <br />
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPagePrereqImpactFig20b']"
            alt=""
          />
          <p class="picture-caption">Figure 20a: Prerequisite Filter</p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will get a table just like the
            screenshot (Figure 21) below.
          </li>
          <br />
          <div>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPagePrereqImpactFig21']"
              alt=""
            />
            <p class="picture-caption">
              Figure 21: Prerequisite Impact Results
            </p>
          </div>
          <li>
            Click on a row of a table to get an expanded table. The table will
            expand below displaying a graph (Figure 22) for grades awarded in
            each prerequisite courses for the target course.
          </li>
          <br />
          <div>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPagePrereqImpactFig22']"
              alt=""
            />
            <p class="picture-caption">
              Figure 22: Awarded Grades Graph in Prerequisite Impact
            </p>
          </div>
          <li>
            There will also be buttons above the graph to toggle between each
            prerequisite course graphs (Figure 22a). To show additional
            information about the prerequisite courses for the course number
            that was entered in the form field.
          </li>
          <div>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPagePrereqImpactFig22a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 22a: Prerequisite Toggle Buttons in Prerequisite Impact
              Page
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Prerequisite Impact',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
